import { resolveNotificationLaneId } from '../../../shared/utils/gate-lane.util';

/** Staff UI image upload via POST order/get-lp-image (stamps header lane onto the payload). */
export function isUiLprImageUploadNotificationData(
  data: Record<string, any> | undefined
): boolean {
  return data?.['is_lpr_upload'] === true || data?.['isLprUpload'] === true;
}

/**
 * Location/lane for PUT order/lpr-entries/:id after UI image scan.
 * Keeps the LPR row aligned with the order-request dropdowns (scan context may differ).
 */
export function buildLprEntryLocationLanePutFields(options: {
  notificationData?: Record<string, any>;
  locationId?: string | null;
  laneId?: string | null;
}): { location_id?: string; lane_id?: string } {
  if (!isUiLprImageUploadNotificationData(options.notificationData)) {
    return {};
  }

  const fields: { location_id?: string; lane_id?: string } = {};
  const locationId = options.locationId != null ? String(options.locationId).trim() : '';
  if (locationId) {
    fields.location_id = locationId;
  }
  const laneId = options.laneId != null ? String(options.laneId).trim() : '';
  if (laneId) {
    fields.lane_id = laneId;
  }
  return fields;
}

/**
 * Lane for POST /order.
 * Prefer an explicit form selection. Camera LPR keeps notification lane_id.
 * UI image scan ignores stamped notification / header lane unless selected on the form.
 * Header "+" (quick_plus / omitLane) may schedule without a lane when no lane picker applies.
 */
export function buildCreateOrderLaneIdPayload(options: {
  omitLane?: boolean;
  selectedLaneId?: string | null;
  notificationData?: Record<string, any>;
  fallbackLaneId?: string | null;
}): { lane_id: string } | Record<string, never> {
  if (options.omitLane) {
    return {};
  }

  const selected = options.selectedLaneId != null ? String(options.selectedLaneId).trim() : '';
  if (selected) {
    return { lane_id: selected };
  }

  // UI upload: stamped notification / header lane is not ground truth — only an explicit form selection.
  if (isUiLprImageUploadNotificationData(options.notificationData)) {
    return {};
  }

  const fallback = options.fallbackLaneId != null ? String(options.fallbackLaneId).trim() : '';
  const fromNotification = resolveNotificationLaneId(options.notificationData).trim();
  const laneId = fromNotification || fallback || '';
  return laneId ? { lane_id: laneId } : {};
}
